export function truthyBoolean(v) {
  return v === true || v === "true";
}
